module.exports = __webpack_public_path__ + "files/40711e15b4294b3db1df8c8f71aeeb50.svg";